module.exports = __webpack_public_path__ + "img/dl4.ac23a176.jpg";